import { useEffect, useState } from "react";
import { toast } from "sonner";
import { getProject, getVocalJob, listVocalJobs, replaceVocal } from "@/lib/studioApi";
import { safeApiError } from "@/lib/safeErrorText";

const POLL_MS = 2500;

/** Start a lead-vocal replacement, follow it to the end, then hand the refreshed project back. */
export default function useVocalJob(projectId, versionId, onProject) {
  const [job, setJob] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    listVocalJobs(projectId, versionId).then((rows) => { if (rows?.[0]?.status === "running") setJob(rows[0]); }).catch(() => null);
  }, [projectId, versionId]);

  const running = job?.status === "running";
  const jobId = job?.id;
  useEffect(() => {
    if (!running) return undefined;
    const t = setInterval(async () => {
      try {
        const j = await getVocalJob(projectId, jobId);
        if (j.status === "done") onProject(await getProject(projectId));
        setJob(j);
      } catch { /* keep polling */ }
    }, POLL_MS);
    return () => clearInterval(t);
  }, [running, projectId, jobId, onProject]);

  const start = async (body) => {
    setBusy(true);
    try { setJob(await replaceVocal(projectId, { version_id: versionId, ...body })); }
    catch (e) { toast.error("Couldn't start the replacement", { description: safeApiError(e) }); }
    finally { setBusy(false); }
  };
  return { job, start, busy };
}
